module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ECECEC"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "100px 0",
      "margin": "auto",
      "width": "1200px"
    }
  }, [_c('div', {
    staticClass: "company left"
  }, [_c('p', [_vm._v("热线：4008-365596")]), _vm._v(" "), _c('p', [_vm._v("商务合作：caoqifan@ttq.so")]), _vm._v(" "), _c('p', [_vm._v("微信客服：ttqcare")])]), _vm._v(" "), _c('div', {
    staticClass: "companyErcode right"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/weibo.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("官方微博")])]), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/gongzhonghao.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("官方公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/shipinhao.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("官方视频号")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/douyin.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("抖音号")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "beian"
  }, [_c('a', {
    staticStyle: {
      "color": "#00b9cd"
    },
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("粤ICP备14072944号")]), _vm._v("  |   版权所有权Copyright @ 2014-2024 深圳市爱宝惟生物科技有限公司  |   地址：广东省深圳市宝安西乡街道宝民二路IDT研发中心4层  |  电话：0755-29299992                \n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce2ba50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/footerBottomer.vue
// module id = 185
// module chunks = 1